import { sign as aws4Sign } from 'aws4';
import { AxiosRequestConfig } from 'axios';

import { Signer } from '../signer';
import { Credentials } from '../types';
import { AWSCredentials } from './aws-credentials';
import { AWSRequestConfig } from './aws-request-config';
import { AWS4SignerConfig } from './types';

export class AWS4Signer extends Signer<AWS4SignerConfig, AWSRequestConfig, Credentials> {
  /**
   * Signs the request with aws4 sign algorithm.
   * @param {AxiosRequestConfig} axiosRequestConfig
   * @param {Credentials} credentials
   * @returns {RequestConfig} signed request config
   * @throws {Error} if the aws signed request configuration is invalid
   */
  public sign(axiosRequestConfig: AxiosRequestConfig, credentials: Credentials): AWSRequestConfig | never {
    const formattedCreds = credentials.getFormatted();

    if (!formattedCreds) {
      throw new Error('Invalid AWSCredentials for AWS4Signer Class');
    }

    const awsRequestConfig = new AWSRequestConfig(axiosRequestConfig, this.getConfig(), credentials as AWSCredentials);

    awsRequestConfig.validate();

    const signedRequestConfig = aws4Sign(awsRequestConfig.getConfig(), formattedCreds);

    awsRequestConfig.updateConfig(signedRequestConfig);

    awsRequestConfig.addJWTAuthorizationHeader(credentials as AWSCredentials);

    return awsRequestConfig;
  }
}
